import { render, staticRenderFns } from "./EditAccountRoleDialog.vue?vue&type=template&id=af0e0978&scoped=true"
import script from "./EditAccountRoleDialog.vue?vue&type=script&lang=js"
export * from "./EditAccountRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAccountRoleDialog.vue?vue&type=style&index=0&id=af0e0978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0e0978",
  null
  
)

export default component.exports